import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import mainLogo from '../../images/logo-edenred.png';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { BreadCrumb } from 'primereact/breadcrumb';
import { useEffect, useState } from "react";
import { populateNavbarData } from './services/navbar.service';
import { useGlobalContext } from "../../pages/shared/context/global.context";
import { getVerificar } from '../../pages/shared/services/verificarCarga.service';
import './NavBar.css';
import { IMenu } from '../../pages/shared/models/menu.models';
import { PCOM_ROUTES } from '../../pages/shared/models/routes';



type BreadCrumbNavItem = Omit<IMenu, 'items' | 'url'> & { url?: string };

interface IState {
    menu?: IMenu[],
    crumbThree?: Map<string, BreadCrumbNavItem[]>,
    isOpen: boolean
}
interface VerificarResult {
    comerciosString: string;
    todos: boolean
}

const NavBar = () => {
    const URL_HOME = 'Home';
    const { setVerificarCarga, userLogged, comercioSelecionado,setAllowedRoutes } = useGlobalContext()
    const [loadingMenu, setLoadingMenu] = useState(false);
    const [activePage, setActivePage] = useState(window.location.pathname.replace('/', ''));
    const [state, setState] = useState<IState>(
        { isOpen: false, menu: [], crumbThree: new Map<string, BreadCrumbNavItem[]>() }
    )

    const location = useLocation()

    useEffect(() => { setActivePage(window.location.pathname); }, [useLocation()])

    useEffect(() => {
        if (comercioSelecionado.length === 0) return
        comercioSelecionado.length > 0 ? setLoadingMenu(true) : setLoadingMenu(false)
    }, [comercioSelecionado])

    useEffect(() => {
        (async () => {
            if (!userLogged) return
            const { data, status } = await getVerificar()
            if (status === 200) {
                if (Object.keys(data).length > 0) {
                    await getMenu(data)
                    setVerificarCarga(data)
                }
            }
        }
        )();
    }, [userLogged])

    const mapMenuToBreadcrumb: (toMap: IMenu) => BreadCrumbNavItem[][] = (toMap) => {
        if (toMap.items == null || toMap.items == undefined || toMap.items.length == 0) return [[{ label: toMap.label, url: toMap.url }]];

        return toMap.items.map(m => {
            return mapMenuToBreadcrumb(m)
                .map(mpp => {
                    mpp.unshift({ label: toMap.label });

                    return mpp;
                });
        }).flat();
    }

    const updateBreadCrumbMenu: (menus: IMenu[]) => Map<string, BreadCrumbNavItem[]> = (menus) => {
        let crMenu = new Map<string, BreadCrumbNavItem[]>();

        menus.map(m => mapMenuToBreadcrumb(m))
            .flat()
            .forEach(mp => {
                if (mp.length < 1) return;

                /* Hace push y pop en vez de [lenght - 1] porque es mucho mas rapido */
                let endOfPathItem = mp.pop();
                mp.push(endOfPathItem!);
                crMenu.set(`${process.env.PUBLIC_URL}/${endOfPathItem?.url!}`, mp);
            });
        return crMenu;
    }

    const getMenu = async (verificarCarga: VerificarResult) => {
        const { data, status } = await populateNavbarData()
        let result = data.menus.menu;

        if (verificarCarga.comerciosString && !verificarCarga.todos) result = result.filter((it: IMenu) => it.url !== "CambiarComercio");
        let brMenu = updateBreadCrumbMenu(result);

        brMenu.set(`${process.env.PUBLIC_URL}/cargarPrsentacion`, [{ label: 'Presentaciones', url: PCOM_ROUTES.PRESENTACIONES }, { label: 'Cargar Presentación', url: '' }]);
        brMenu.delete(`${process.env.PUBLIC_URL}/Home`)

        setState({ ...state, menu: result, crumbThree: brMenu });
        let routes = structuredClone(result);     
        if (routes.some((r: { url: any; }) => r.url.toLocaleLowerCase() === PCOM_ROUTES.PRESENTACIONES)) 
        {
            routes.push({ label: 'Cargar Presentacion', url: PCOM_ROUTES.CARGAR_PRESENTACION })
        };

        setAllowedRoutes(routes)
    }

    function toggle() {
        setState({ ...state, isOpen: !state.isOpen });
    }

    if (state.menu == null) {
        return (
            <div>

            </div>
        )
    }

    return (

        <div className="layout-menu" style={{ paddingLeft: '0px' }}>
            <Navbar color="inverse" light expand="md" style={{ justifyContent: 'flex-start', paddingLeft: '0px', height: '8rem' }}>
                <NavbarBrand style={{ cursor: 'pointer', display: 'inline-flex', flexDirection: 'column', paddingLeft: '0px' }}>
                    <a href={URL_HOME} className='container' style={{ display: 'inline-flex', justifyContent: 'flex-start', paddingLeft: '0px' }}>
                        <img src={mainLogo} style={{ height: '5rem' }} alt="Edenred" />
                        <div style={{
                            fontFamily: 'Edenred,Montserrat,sans-serif',
                            fontSize: '1.5em', color: '#162056', lineHeight: '30px',
                            textAlign: 'right', paddingLeft: '10px', fontWeight: 'bolder'
                        }} >
                            Portal Comercios
                        </div>
                    </a>
                    {loadingMenu && state.crumbThree?.size != 0 &&
                        <BreadCrumb
                            className="eden-com-bcrumb"
                            model={state.crumbThree?.get(activePage)}
                            home={{ icon: 'pi pi-home', url: URL_HOME }} />}
                </NavbarBrand>
                <NavbarToggler onClick={toggle} />
                <Collapse isOpen={state.isOpen} navbar>
                    <Nav navbar>
                        {loadingMenu && state.menu.map(function (item) {
                            return (item.url != "" ?
                                item.url.indexOf("http") > -1 ?
                                    <NavItem key={item.label.toString().replace(" ", "")}>
                                        <a onClick={() => setActivePage(item.url)} href={item.url} style={{ cursor: 'pointer', fontSize: '13px' }} target="_blank">
                                            {item.label}
                                        </a>
                                    </NavItem>
                                    :
                                    <NavItem key={item.label.toString().replace(" ", "")}>
                                        <Link onClick={() => setActivePage(item.url)} to={"/" + item.url} style={{ cursor: 'pointer', fontSize: '13px' }}>
                                            {item.label}
                                        </Link>
                                    </NavItem>
                                :
                                <UncontrolledDropdown nav inNavbar key={item.label.toString().replace(" ", "")}>
                                    <DropdownToggle style={{ fontSize: '13px' }} nav caret>
                                        {item.label}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {
                                            item.items.map(function (item) {
                                                return item.url.indexOf("http") > -1 ?
                                                    <DropdownItem key={item.label.toString().replace(" ", "")}>
                                                        <NavItem key={item.label.toString().replace(" ", "")}>
                                                            <a onClick={() => setActivePage(item.url)} href={item.url} style={{ cursor: 'pointer', fontSize: '13px' }} target="_blank">
                                                                {item.label}
                                                            </a>
                                                        </NavItem>
                                                    </DropdownItem>
                                                    :
                                                    <DropdownItem key={item.label.toString().replace(" ", "")}>
                                                        <NavItem key={item.label.toString().replace(" ", "")}>
                                                            <Link onClick={() => setActivePage(item.url)} to={"/" + item.url} style={{ cursor: 'pointer', fontSize: '13px' }}>
                                                                {item.label}
                                                            </Link>
                                                        </NavItem>
                                                    </DropdownItem>
                                            })
                                        }
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            )
                        })}
                    </Nav>
                </Collapse>
            </Navbar>
        </div>
    );
}

export default NavBar